<template>
    <div class="">
          <br>
        <div class="row container-fluid">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-6">
                <h1 class="titlequestion">{{$t('modify.mod19')}}</h1>
                <h1 class="titlequestion">{{$t('modify.mod20')}} {{data.id}} </h1>
            </div>
            <div class="col-sm-5">
                <button @click="salir" class="btn btn-secondary float-right" style="margin-right:17%; border-radius:0px">{{$t('step5.lbl16')}}</button>
            </div>
        </div>
        <br>
      <hr>
      <div class="container-fluid">
          <div class="row">
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-body">

                            <h2 class="titledetails">{{$t('step5.st2')}}</h2>
                            <div class="row">
                                <div class="col-sm-8">
                                    <h3>{{$t('step5.st3')}}</h3>
                                    <span class="spanXtras">{{ calculo.reserva.fecha_ret }} {{calculo.reserva.hora_ret}}</span>
                                    <span class="spanXtras">{{calculo.reserva.fecha_dev}}, {{calculo.reserva.hora_dev}}</span>
                                </div>
                                <div class="col-sm-4 modificar">
                                    <!-- <router-link class="btnModificar" to="/reservedatetime">modificar</router-link> -->
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm-8">
                                    <h3>{{$t('step5.st4')}}</h3>
                                    <span class="spanXtras">{{calculo.reserva.nombre_ciudad_ret}}</span>
                                    <span class="spanXtras">{{calculo.reserva.nombre_ciudad_dev}}</span>
                                </div>
                                <div class="col-sm-4 modificar">
                                    <!-- <a href="#" class="btnModificar">modificar</a> -->
                                </div>
                            </div>
                            <br>

                        </div>
                    </div>
                    <br>
                    
                <div class="card">
                        <div class="card-body">

                            <!--/////////-->

                            <div class="row">
                                <div class="col-sm-8">
                                    <!-- <h2 class="titledetails">{{auto.categoria}} este</h2> -->

                                    <div v-if="$i18n.locale==='en'">
                                      <h2 v-if="auto.categoria.categoria==='Economicos'" class="titledetails">Economic</h2>
                                      <h2 v-else-if="auto.categoria.categoria==='Sedan'" class="titledetails">Sedan</h2>
                                      <h2 v-else-if="auto.categoria.categoria==='Premium'" class="titledetails">Premium</h2>
                                      <h2 v-else-if="auto.categoria.categoria==='Lujo'" class="titledetails">Luxury</h2>
                                      <h2 v-else-if="auto.categoria.categoria==='Grande'" class="titledetails">Fullsize</h2>
                                    </div>
                                    <h2 v-else class="titledetails">{{auto.categoria.categoria}}</h2>

                                    <span>{{auto.marca}} {{auto.modelo}}</span><br>
                                    <span><i class="icon-transmission ic"></i> {{auto.transmision}}</span>
                                </div>
                                <div class="col-sm-4">
                                    <img :src="auto.image.url_imagen" class="img-categoria" alt="">
                                </div>
                            </div>

                            <!--/////////-->

                            <div class="row mt-4">

                                <div class="col-sm-9">

                                    <h3>{{$t('stepnav.st3')}}</h3>
                                    <span>{{$t('step5.st6')}}</span>
                                    
                                </div>

                                <div class="col-sm-3">

                                    <!-- <div class="modificar"><router-link class="btnModificar" :to="{name: 'Reservestep4'}">modificar</router-link></div> -->
                                    <span style="float:right;">US$ {{parseFloat(calculo.detalle.tarifa).toFixed(2)}}</span>
                                    

                                </div>

                            </div>

                            <!--/////////-->

                            <div class="row mt-4">
                                
                                <div class="col-sm-12">

                                    <h3>{{$t('nav_bar_reservas.complementos')}}</h3>
                                    <div class="modificar"><router-link class="btnModificar" :to="{name: 'Reservestep4'}">modificar</router-link></div> 
                                    <span v-if="arraySolicitado.includes(calculo.detalle.coberturas.siglas[0])">{{ calculo.detalle.coberturas.nombre[0]}} 
                                        <span class="float-right">US$ {{ calculo.detalle.coberturas.monto[0] }}</span>
                                        <br>
                                    </span>
                                    <span v-else></span>
                                    <span v-if="arraySolicitado.includes(calculo.detalle.coberturas.siglas[1])">{{ calculo.detalle.coberturas.nombre[1]}} 
                                        <span class="float-right">US$ {{ calculo.detalle.coberturas.monto[1] }}</span>
                                        <br>
                                    </span>
                                    <span v-else></span>
                                    <span v-if="arraySolicitado.includes(calculo.detalle.coberturas.siglas[2])">{{ calculo.detalle.coberturas.nombre[2]}} 
                                        <span class="float-right">US$ {{ calculo.detalle.coberturas.monto[2] }}</span>
                                        <br>
                                    </span>
                                    <span v-else></span>
                                    <span v-if="arraySolicitado.includes(calculo.detalle.coberturas.siglas[3])">{{ calculo.detalle.coberturas.nombre[3]}} 
                                        <span class="float-right">US$ {{ calculo.detalle.coberturas.monto[3] }}</span>
                                        <br>
                                    </span>
                                    <span v-else></span>

                                    <!--accesorios-->
                                    <span v-if="arraySolicitadoAcc.includes(calculo.detalle.accesorios.siglas[0])">{{ calculo.detalle.accesorios.nombre[0]}} 
                                        <span class="float-right">US$ {{ calculo.detalle.accesorios.monto[0] }}</span>
                                        <br>
                                    </span>
                                    <span v-else></span>
                                    <span v-if="arraySolicitadoAcc.includes(calculo.detalle.accesorios.siglas[1])">{{ calculo.detalle.accesorios.nombre[1]}} 
                                        <span class="float-right">US$ {{ calculo.detalle.accesorios.monto[1] }}</span>
                                        <br>
                                    </span>
                                    <span v-else></span>

                                    <!--conductor adcional-->
                                    <span v-if="data.conductor_adicional > 0">{{$t('extras.drv2')}}({{data.conductor_adicional}})
                                        <span class="float-right">US$ {{ parseFloat(calculo.detalle.conductor_adicional * data.conductor_adicional).toFixed(2)}}</span>
                                        <br>
                                    </span><span v-else></span>


                                </div>
                            
                                

                            </div>

                             <!--/////////-->

                            <div class="row mt-4">

                                <div class="col-sm-12">
                                    <h3>{{$t('step5.st10')}}</h3>
                                </div>
                            </div>

                            <div class="row mt-1">

                                <div class="col-sm-6">
                                    <span>{{$t('step5.st11')}}</span><br>
                                    <span>Subtotal</span><br>
                                    <span>{{$t('step5.st13')}}</span>
                                </div>
                                <div class="col-sm-6">
                                        <span class="float-right">US$ {{ parseFloat(calculo.detalle.apo_fee).toFixed(2) }}</span><br>
                                        <span class="float-right">US$ {{ parseFloat(calculo.detalle.subtotal).toFixed(2) }}</span><br>
                                        <span class="float-right">US$ {{ parseFloat(calculo.detalle.itbm).toFixed(2) }}</span>
                                    
                                </div>


                            </div>

                            <!--/////////-->

                            <!--/////////-->
                            <hr>
                            <div class="row mt-4">

                                <div class="col-sm-6">

                                    <h3>{{$t('step5.st14')}}</h3>
                                    
                                </div>

                                <div class="col-sm-6">

                                    <span style="float:right;font-size:30px;"><strong>US$ {{parseFloat(calculo.detalle.total).toFixed(2)}}</strong></span>

                                </div>

                            </div>

                            <!--/////////-->

                        </div>
                    </div>
                    <br>
                    <div class="card">
                        <div class="card-body">
                            <div class="card-body">

                                <h2 class="titledetails">{{$t('step5.st15')}}</h2>

                                <b-row>
                                    <b-col>
                                        <ul>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st16')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st17')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st18')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st19')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20_1')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20_2')}}</a></li>
                                        </ul>
                                    </b-col>
                                </b-row>
                                <!-- modal for policies -->
                                <div 
                                class="modal fade" 
                                id="policiesModal" 
                                tabindex="-1" 
                                aria-labelledby="policies-modal" 
                                aria-hidden="true">
                                  <div class="modal-dialog modal-xl">
                                    <div class="modal-content rounded-0">
                                      <div 
                                      class="modal-header rounded-0" 
                                      style="background-color:#169a5a;">
                                        <h5 class="modal-title modaltitle" id="policies-modal">{{$t('modalpolicy.pol1')}}</h5>
                                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                          <span aria-hidden="true">&times;</span>
                                        </button>
                                      </div>
                                      <div class="modal-body">
                                        <b-row>
                                          <b-col md="5">
                                              <div style="margin-top:-17px"  class="nav flex-column " id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                <a class="btnpolicies nav-link active" id="v-pills-1-tab" data-toggle="pill" href="#v-pills-1" role="tab" aria-controls="v-pills-1" aria-selected="true">
                                                  <p class="ml-3">{{$t('modalpolicy.pol2')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-2-tab" data-toggle="pill" href="#v-pills-2" role="tab" aria-controls="v-pills-2" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol3')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-3-tab" data-toggle="pill" href="#v-pills-3" role="tab" aria-controls="v-pills-3" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol5')}} 
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-4-tab" data-toggle="pill" href="#v-pills-4" role="tab" aria-controls="v-pills-4" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol7')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-5-tab" data-toggle="pill" href="#v-pills-5" role="tab" aria-controls="v-pills-5" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol9')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-6-tab" data-toggle="pill" href="#v-pills-6" role="tab" aria-controls="v-pills-6" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol11')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-7-tab" data-toggle="pill" href="#v-pills-7" role="tab" aria-controls="v-pills-7" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol13')}}
                                                  </p>
                                                </a>
                                              </div>
                                          </b-col>
                                          <b-col md>
                                            <div class="tab-content" id="v-pills-tabContent">
                                              <div class="tab-pane fade show active" id="v-pills-1" role="tabpanel" aria-labelledby="v-pills-1-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol2')}}</p>
                                                <renttermscomp/>
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-2" role="tabpanel" aria-labelledby="v-pills-2-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol3')}}</p>
                                               {{$t('modalpolicy.pol4')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-3" role="tabpanel" aria-labelledby="v-pills-3-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol5')}} </p>
                                                {{$t('modalpolicy.pol6')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-4" role="tabpanel" aria-labelledby="v-pills-4-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol7')}}</p>
                                                {{$t('modalpolicy.pol8')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-5" role="tabpanel" aria-labelledby="v-pills-5-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol9')}}</p>
                                                {{$t('modalpolicy.pol10')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-6" role="tabpanel" aria-labelledby="v-pills-6-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol11')}}</p>
                                                {{$t('modalpolicy.pol12')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-7" role="tabpanel" aria-labelledby="v-pills-7-tab">
                                                <p
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol13')}}</p>
                                                {{$t('modalpolicy.pol14')}}
                                              </div>
                                            </div>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <form @submit.prevent="modificar">
                        <!-- primer card del formulario-->
                    <div class="card2">
                        <div>
                            <span></span>
                        </div>
                        <div class="card-header">
                            <h2>{{$t('step5.st22')}}</h2></div>
                        <div class="card-body">

                            <!--primer recuadro del formulario-->
                            <div class="row">

                                <div class="col-sm-6">

                                    <label for="inputPassport">{{$t('step5.lbl1')}}</label>
                                    <input disabled type="text" id="inputPassport" class="form-control" v-model='data.cedula' required>
                                    <br>
                                    <label for="inputLastname">{{$t('step5.lbl3')}}</label>
                                    <input disabled type="text" id="inputLastname" class="form-control" v-model='data.apellido_paterno' required>
                                    <br>
                                    <label for="inputEmail">{{$t('step5.lbl5')}}</label>
                                    <input disabled type="email" id="inputEmail" class="form-control" v-model='data.email' required>
                                    <br>
                                    <!-- <div class="row">

                                        <div class="col-sm-5">
                                            <label for="inputpref">Prefijo</label>
                                            <input disabled type="text" id="inputpref" class="form-control" v-model='sendReservation.prefijo'>
                                        </div>

                                        <div class="col-sm-7">
                                            <label for="inputphone">Teléfono *</label>
                                            <input disabled type="text" id="inputphone" class="form-control" v-model='sendReservation.tel' required>
                                        </div>

                                    </div> -->
                                </div>
                                <div class="col-sm-6">

                                    <label for="inputName">{{$t('step5.lbl2')}}</label>
                                    <input disabled type="text" id="inputName" class="form-control" v-model='data.nombre' required>
                                    <br>
                                    <label for="inputMname">{{$t('step5.lbl4')}}</label>
                                    <input disabled type="text" id="inputMname" class="form-control" v-model='data.apellido_materno'>
                                    <br>
                                    <label for="inputCountry">{{$t('step5.lbl6')}}</label>
                                    <input disabled type="text" id="inputCountry" class="form-control" v-model='data.pais' required>
                                    <br>
                                    <!-- <label for="inputPago">Forma de Pago *</label> -->
                                    <!-- <select class="form-control" id="inputPago" v-model='sendReservation.forma_pago' :required="true">
                                        <option 
                                                v-for="fp in forma_pago" 
                                                :key="fp.id" 
                                                :value="fp.id">
                                                {{fp.forma_pago}}
                                        </option>
                                    </select> -->
                                </div>

                            </div>
                            <br>

                        </div>
                    </div>
                    <!-- primer card del formulario-->
                    <br>
                    <!-- primer card del formulario-->
                    <div class="card2" v-show="!isAuth">
                        <div class="card-header">
                            <h2>{{$t('step5.st24')}}</h2></div>
                        <div class="card-body">

                            <!--primer recuadro del formulario-->
                            <div class="row">

                                <div class="col-sm-6">

                                    <label for="inputLic">{{$t('step5.lbl10')}}</label>
                                    <input type="text" id="inputLic" class="form-control" v-model='data.licencia'>
                                    
                                </div>

                                <div class="col-sm-6">

                                    <label for="inputCel">{{$t('step5.lbl11')}}</label>
                                    <input type="text" id="inputCel" class="form-control" v-model='data.celular'>
                                    
                                </div>

                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm-12">
                                    <label for="inputOb">{{$t('step5.lbl12')}}</label>
                                    <textarea name="" id="inputOb" class="form-control" v-model='data.observaciones'></textarea>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- primer card del formulario-->
                    <br>
                    <!-- primer card del formulario-->
                    <div class="card2" v-show="!isAuth">
                        <div class="card-header">
                            <h2>{{$t('step5.st25')}}</h2></div>
                        <div class="card-body">

                            <!--primer recuadro del formulario-->
                            <div class="row">

                                <div class="col-sm-6">

                                    <label for="inputLin">{{$t('step5.lbl13')}}</label>
                                    <input type="text" id="inputLin" class="form-control" v-model='data.linea_aerea'>
                                    
                                </div>

                                <div class="col-sm-6">

                                    <label for="inputVuelo">{{$t('step5.lbl14')}}</label>
                                    <input type="text" id="inputVuelo" class="form-control" v-model='data.num_vuelo'>
                                    
                                </div>

                            </div>
                        
                        </div>
                    </div>
                    <br>
                    <!-- primer card del formulario-->

                    <!-- primer card del formulario-->
                    <div class="card2">
                        <div class="card-header">
                            <h2>{{$t('step5.st26')}}</h2></div>
                        <div class="card-body">

                            <!--primer recuadro del formulario-->
                            <div class="row">

                                <div class="col-sm-6">

                                    <span>{{$t('step5.st27')}}</span>
                                    
                                </div>

                                <div class="col-sm-6">

                                    <sup class="valor float-right">US$ {{parseFloat(calculo.detalle.total).toFixed(2)}}</sup>
                                    
                                </div>

                            </div>
                        
                        </div>
                    </div>
                    <!-- primer card del formulario-->
                    <br>
                    <button class="btnConfirm" type="submit">{{$t('step5.lbl15')}}</button>
                    <button @click="salir" type="button" class="btnConfirm ml-2" style="background-color:#5A6268;">{{$t('step5.lbl16')}}</button>
                    </form>
                </div>
                <div class="col-sm-1">

                </div>
                <modalupdate/>

                <br>
          </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import renttermscomp      from '@/components/renttermscomp.vue'
import moment from 'moment'
import modalupdate from '@/components/updatemodalsuccess'
    export default {
        components: {
            modalupdate,
            renttermscomp
        },
        mounted () {
            if(this.accion_modificar === false)
            {
                this.$router.push({path: '/'})
            }
        },
        computed: {
            ...mapState('reserva', ['sendReservation', 'montoExtras', 'subTotal', 'apo_fee', 'itbms', 'tarifa', 'calculo', 'auto']),
            ...mapState('autenticacion', ['user']),
            ...mapState('reservav2', ['accion_modificar', 'calculo', 'data', 'auto']),
            ...mapGetters('autenticacion', ['isAuth']),
            fecha_salida()
                {
                    console.log(this.sendReservation.fecha_retiro)
                    return moment(this.sendReservation.fecha_retiro).format('D MMMM YYYY')
                },
            fecha_entrega()
                {
                    console.log(this.sendReservation)
                    return moment(this.sendReservation.fecha_devolucion).format('D MMMM YYYY')
                },
            hora_salida()
                {
                    return moment(this.sendReservation.hora_retiro, "h:mm A").format('LT')
                },
            hora_entrega()
                {
                    return moment(this.sendReservation.hora_devolucion, "h:mm A").format('LT')
                },
            arraySolicitado()
            {
                let solicitado = this.calculo.detalle.coberturas.solicitado
                if(solicitado == null){
                    let comparar = "0,0"
                    let usingSplit = comparar.split(',')
                    return usingSplit
                }else{
                    const usingSplit = solicitado.split(',');
                    return usingSplit
                }
            },
            arraySolicitadoAcc()
            {
                let solicitado = this.calculo.detalle.accesorios.solicitado

                if(solicitado == null){
                    let comparar = "0,0"
                    let usingSplit = comparar.split(',')
                    return usingSplit
                }else{
                    const usingSplit = solicitado.split(',');
                    return usingSplit
                }
                
            }
        },
        methods: {
            salir() {
                location.replace('/'); 
            },
            ...mapActions('reservav2', ['actualizarReserva']),
            async modificar()
            {
                await $('#updateModal').modal('show')
            }
        },
    }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   //margin-left: 30px;
   font-weight: 800;
   color: #181918;
   text-transform: uppercase;
}
.card{
    border: 1px solid #c3c3c3;
    border-radius: 0px;
    padding: 20px 31px 18px 17px;
    background-color: #f3f3f3;
}
.card2{
    border: 1px solid #c3c3c3;
    border-radius: 0px;
    padding: 41px 31px 18px 31px;
    background-color: #ffffff;
}
.card-header {
    padding: 0px;
    margin-bottom: 0;
    background-color: rgba(255, 255, 255, 0.03);
    border-bottom: 2px solid rgb(0, 0, 0);
}
.titledetails {
    font-weight: 600;
    font-style: normal;
    font-size: 1.625rem;
    text-transform: none;
    margin-bottom: 1.375rem;
    line-height: 20px;   
}
.modificar{
    text-align: right;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 900;
}
.btnModificar{
    color: #169a5a;
    cursor: pointer;
}
h3{
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
    font-size: .875rem;
    color: inherit;
}
span {
    font-weight: 200;
    font-style: normal;
    font-size: 14px;
    //margin-bottom: .25rem;
    //display: block;
    max-width: 79%;
}
.spanXtras
{
    margin-bottom: .25rem;
    display: block;
}
.form-control{
    border-radius: 0px;
}
.btnConfirm{
    
    font-weight: 700;
    font-style: normal;
    display: inline-block;
    padding: 0.5em 1em;
    border: 0;
    margin: 0;
    min-height: auto;
    background: #169a5a;
    color: white;
    line-height: inherit;
    letter-spacing: .0675rem;
    font-size: .875rem;
    text-align: center;
    text-transform: uppercase;

}
.valor{
    font-size: 25px;
    padding: 23px 23px 0px;
}
.img-categoria{
    width: 122px;
    float:right;
}
.icon-transmission{
    background-image: url('/img/transmission_type.svg');
    background-size: 100%;
    background-repeat: no-repeat;
}
.ic{
    display: inline-block;
    width: 17px;
    height: 16px;
}

.btnpolicies{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 14px;
  background-color: #f3f3f3; /*  background */
  color: #169A5A !important; /*  text */
  cursor: pointer !important; /* Pointer/hand icon */
  border: none;
  width: 100% !important; /* Set a width if needed */
  height: 41px;
  display: block; /* Make the buttons appear below each other */
  margin-left: -16px;
  border-bottom: 1px solid #a3a4a5 !important;
  background: url("/img/arrowright.png") no-repeat right/10px ;
}
.btnpolicies .btnpolicies:not(:last-child) {
  border-bottom: none; /* Prevent double borders */
}

/* Add a background color on hover */
.btnpolicies:active {
  background-color: #15804d;
}
.btnpolicies:focus {
  background-color: #006639;
  outline: none !important;
  color: #fff !important;
}
.modaltitle{
  font-family: 'DIN 2014-Regular';
  font-size: 16px;
  color: #fff;
}
</style>